import React from 'react'

export const RowItem = (props: any) => {
  return (
    <div className="table-row-item">
      <div className="table-row-item__inner">{props.children}</div>
    </div>
  )
}
